

























import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { Notification } from "@/store/notification/types";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "AgroNotification",
  components: {
    AgroIcons
  }
})
export default class AgroNotification extends Vue {
  @Prop({ type: Object, required: true }) private notification!: Notification;

  private timer: number | null = null;

  @Watch("notification", { immediate: true })
  private setupNotification(notification: Notification) {
    if (notification.autoClose) {
      this.timer = setTimeout(() => {
        this.closeNotification(notification);
      }, notification.timer);
    }
  }

  @Emit("close-notification")
  private closeNotification(notification: Notification) {}
}
